import type { State } from '../../types';
import type { ExternalConnectionViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function externalConnectionsNotDeleted(state: State): ExternalConnectionViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.externalConnectionsById).filter((e) => !e.deleted);
}
